import React, {
  useState,
  useCallback,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Form from 'react-bootstrap/Form';
import { Formik } from 'formik';
import { IoArrowBackOutline, IoArrowForwardOutline } from 'react-icons/io5';
import { DateTime } from 'luxon';

import {
  Card,
  CardHeader,
  CardBody,
  Button,
  FormCurrencyField,
  CardFooter,
} from '_components/_core';

function ManualPayroll({
  company,
  manualPayroll,
  isLoading,
  onFetchManualPayroll,
  onSaveManualPayroll,
}) {
  const [selectedDate, setSelectedDate] = useState(DateTime.now());

  const handleMonthIncreased = useCallback(() => {
    setSelectedDate((previousDate) => previousDate.plus({ year: 1 }));
  }, []);

  const handleMonthDecreased = useCallback(() => {
    setSelectedDate((previousDate) => previousDate.minus({ year: 1 }));
  }, []);

  useEffect(() => {
    const { id: company_id } = company || {};
    if (!company_id) {
      return;
    }

    const year = Number(selectedDate.toFormat('yyyy'));

    onFetchManualPayroll(company_id, year);
  }, [company, selectedDate, onFetchManualPayroll]);

  const handleSubmitManualPayroll = useCallback((values) => {
    const { id: company_id } = company || {};
    onSaveManualPayroll({
      year: Number(selectedDate.toFormat('yyyy')),
      payroll: {
        ...values,
      },
      company_id,
    });
  }, [onSaveManualPayroll, company, selectedDate]);

  return (
    <>
      <Row>
        <Col xs={12} sm={12} lg={12}>
          <Card className="h-100">
            <CardHeader
              title="Folha de Pagamento Manual"
              description="Preencha o valor bruto da folha de pagamento nos períodos desejados"
              sideContent={(
                <ButtonGroup>
                  <Button variant="secondary" onClick={handleMonthDecreased}>
                    <IoArrowBackOutline />
                  </Button>
                  <Button variant="secondary">
                    <b>
                      {selectedDate.toFormat('yyyy')}
                    </b>
                  </Button>
                  <Button variant="secondary" onClick={handleMonthIncreased}>
                    <IoArrowForwardOutline />
                  </Button>
                </ButtonGroup>
              )}
            />
            <Formik
              initialValues={manualPayroll || {}}
              onSubmit={handleSubmitManualPayroll}
              enableReinitialize
            >
              {({
                handleSubmit,
                values,
              }) => (
                <>
                  <CardBody>
                    <Form onSubmit={handleSubmit}>
                      <Form.Row>
                        {Object.keys(values).map((key) => (
                          <Form.Group key={key} as={Col} md="3">
                            <Form.Label>
                              {key}
                            </Form.Label>
                            <FormCurrencyField
                              name={key}
                              placeholder="Valor da Folha no Mês"
                            />
                          </Form.Group>
                        ))}
                      </Form.Row>
                    </Form>
                  </CardBody>
                  <CardFooter>
                    <Row>
                      <Col>
                        <Button isLoading={isLoading} disabled={isLoading} onClick={handleSubmit}>
                          Confirmar Alterações
                        </Button>
                      </Col>
                    </Row>
                  </CardFooter>
                </>
              )}
            </Formik>
          </Card>
        </Col>
      </Row>
    </>
  );
}

ManualPayroll.defaultProps = {
  isLoading: false,
};

ManualPayroll.propTypes = {
  isLoading: PropTypes.bool,
  company: PropTypes.object,
  manualPayroll: PropTypes.object,
  onFetchManualPayroll: PropTypes.func.isRequired,
  onSaveManualPayroll: PropTypes.func.isRequired,
};

export default ManualPayroll;
